import { render, staticRenderFns } from "./check_product.vue?vue&type=template&id=3b10e2cb&scoped=true"
import script from "./check_product.vue?vue&type=script&lang=js"
export * from "./check_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b10e2cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b10e2cb')) {
      api.createRecord('3b10e2cb', component.options)
    } else {
      api.reload('3b10e2cb', component.options)
    }
    module.hot.accept("./check_product.vue?vue&type=template&id=3b10e2cb&scoped=true", function () {
      api.rerender('3b10e2cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/min_order_quantity/form/components/check_product.vue"
export default component.exports